import React from 'react';

export const ES = () => {
	return (
		<svg
			width='20'
			height='15'
			viewBox='0 0 20 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_11534_5657)'>
				<mask
					id='mask0_11534_5657'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='15'
				>
					<rect width='20' height='15' fill='white' />
				</mask>
				<g mask='url(#mask0_11534_5657)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0V15H20V0H0Z'
						fill='#FFB400'
					/>
					<mask
						id='mask1_11534_5657'
						style={{ maskType: 'luminance' }}
						maskUnits='userSpaceOnUse'
						x='0'
						y='0'
						width='20'
						height='15'
					>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 0V15H20V0H0Z'
							fill='white'
						/>
					</mask>
					<g mask='url(#mask1_11534_5657)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 0V3.75H20V0H0Z'
							fill='#C51918'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 11.25V15H20V11.25H0Z'
							fill='#C51918'
						/>
						<rect
							x='3.13'
							y='6.41998'
							width='0.7'
							height='3.64'
							fill='#F1F9FF'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M4.11001 5.79001H2.85001V6.14001H3.06001V6.42001H3.90001V6.14001H4.11001V5.79001Z'
							fill='#C88A02'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M3.90001 10.27H4.11001V10.62H2.85001V10.27H3.06001V9.98999H3.90001V10.27Z'
							fill='#C88A02'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M3.47999 5.86C3.63232 5.86 3.64781 5.80264 3.73768 5.71697C3.80746 5.65044 3.96999 5.56794 3.96999 5.475C3.96999 5.26237 3.75061 5.09 3.47999 5.09C3.20937 5.09 2.98999 5.26237 2.98999 5.475C2.98999 5.57854 3.10191 5.64777 3.18654 5.71697C3.2757 5.78986 3.34115 5.86 3.47999 5.86Z'
							fill='#AD1619'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M2.85001 10.62H4.11001V11.18C4.11001 11.18 3.95251 11.11 3.79501 11.11C3.63751 11.11 3.48001 11.18 3.48001 11.18C3.48001 11.18 3.32251 11.11 3.16501 11.11C3.00751 11.11 2.85001 11.18 2.85001 11.18V10.62Z'
							fill='#005BBF'
						/>
						<mask
							id='mask2_11534_5657'
							style={{ maskType: 'luminance' }}
							maskUnits='userSpaceOnUse'
							x='2'
							y='10'
							width='3'
							height='2'
						>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M2.85001 10.62H4.11001V11.18C4.11001 11.18 3.95251 11.11 3.79501 11.11C3.63751 11.11 3.48001 11.18 3.48001 11.18C3.48001 11.18 3.32251 11.11 3.16501 11.11C3.00751 11.11 2.85001 11.18 2.85001 11.18V10.62Z'
								fill='white'
							/>
						</mask>
						<g mask='url(#mask2_11534_5657)'>
							<path
								d='M2.83863 11.0699L2.81113 11.0029C2.92461 10.9524 3.0385 10.927 3.15257 10.927C3.22626 10.927 3.26474 10.9373 3.33016 10.9664C3.38763 10.992 3.41741 10.9999 3.48026 10.9999C3.5431 10.9999 3.57289 10.992 3.63035 10.9664C3.69577 10.9373 3.73425 10.927 3.80795 10.927C3.92201 10.927 4.0359 10.9524 4.14939 11.0029L4.12188 11.0699C4.01691 11.0232 3.91234 10.9999 3.80795 10.9999C3.7451 10.9999 3.71531 11.0079 3.65785 11.0335C3.59243 11.0626 3.55395 11.0729 3.48026 11.0729C3.40656 11.0729 3.36808 11.0626 3.30266 11.0335C3.2452 11.0079 3.21541 10.9999 3.15257 10.9999C3.04817 10.9999 2.9436 11.0232 2.83863 11.0699Z'
								fill='white'
							/>
							<path
								d='M2.83863 10.8599L2.81113 10.7929C2.92461 10.7424 3.0385 10.717 3.15257 10.717C3.22626 10.717 3.26474 10.7273 3.33016 10.7564C3.38763 10.782 3.41741 10.79 3.48026 10.79C3.5431 10.79 3.57289 10.782 3.63035 10.7564C3.69577 10.7273 3.73425 10.717 3.80795 10.717C3.92201 10.717 4.0359 10.7424 4.14939 10.7929L4.12188 10.8599C4.01691 10.8132 3.91234 10.79 3.80795 10.79C3.7451 10.79 3.71531 10.7979 3.65785 10.8235C3.59243 10.8526 3.55395 10.8629 3.48026 10.8629C3.40656 10.8629 3.36808 10.8526 3.30266 10.8235C3.2452 10.7979 3.21541 10.79 3.15257 10.79C3.04817 10.79 2.9436 10.8132 2.83863 10.8599Z'
								fill='white'
							/>
						</g>
						<rect
							x='9.98999'
							y='6.41998'
							width='0.7'
							height='3.64'
							fill='#F1F9FF'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M10.97 5.79001H9.70999V6.14001H9.91999V6.42001H10.76V6.14001H10.97V5.79001Z'
							fill='#C88A02'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M10.76 10.27H10.97V10.62H9.70999V10.27H9.91999V9.98999H10.76V10.27Z'
							fill='#C88A02'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M10.34 5.86C10.4923 5.86 10.5078 5.80264 10.5977 5.71697C10.6675 5.65044 10.83 5.56794 10.83 5.475C10.83 5.26237 10.6106 5.09 10.34 5.09C10.0694 5.09 9.85001 5.26237 9.85001 5.475C9.85001 5.57854 9.96193 5.64777 10.0466 5.71697C10.1357 5.78986 10.2012 5.86 10.34 5.86Z'
							fill='#AD1619'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M9.70999 10.62H10.97V11.18C10.97 11.18 10.8125 11.11 10.655 11.11C10.4975 11.11 10.34 11.18 10.34 11.18C10.34 11.18 10.1825 11.11 10.025 11.11C9.86749 11.11 9.70999 11.18 9.70999 11.18V10.62Z'
							fill='#005BBF'
						/>
						<mask
							id='mask3_11534_5657'
							style={{ maskType: 'luminance' }}
							maskUnits='userSpaceOnUse'
							x='9'
							y='10'
							width='2'
							height='2'
						>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M9.70999 10.62H10.97V11.18C10.97 11.18 10.8125 11.11 10.655 11.11C10.4975 11.11 10.34 11.18 10.34 11.18C10.34 11.18 10.1825 11.11 10.025 11.11C9.86749 11.11 9.70999 11.18 9.70999 11.18V10.62Z'
								fill='white'
							/>
						</mask>
						<g mask='url(#mask3_11534_5657)'>
							<path
								d='M9.69861 11.0699L9.67111 11.0029C9.7846 10.9524 9.89849 10.927 10.0126 10.927C10.0862 10.927 10.1247 10.9373 10.1901 10.9664C10.2476 10.992 10.2774 10.9999 10.3402 10.9999C10.4031 10.9999 10.4329 10.992 10.4903 10.9664C10.5558 10.9373 10.5942 10.927 10.6679 10.927C10.782 10.927 10.8959 10.9524 11.0094 11.0029L10.9819 11.0699C10.8769 11.0232 10.7723 10.9999 10.6679 10.9999C10.6051 10.9999 10.5753 11.0079 10.5178 11.0335C10.4524 11.0626 10.4139 11.0729 10.3402 11.0729C10.2665 11.0729 10.2281 11.0626 10.1626 11.0335C10.1052 11.0079 10.0754 10.9999 10.0126 10.9999C9.90816 10.9999 9.80359 11.0232 9.69861 11.0699Z'
								fill='white'
							/>
							<path
								d='M9.69861 10.8599L9.67111 10.7929C9.7846 10.7424 9.89849 10.717 10.0126 10.717C10.0862 10.717 10.1247 10.7273 10.1901 10.7564C10.2476 10.782 10.2774 10.79 10.3402 10.79C10.4031 10.79 10.4329 10.782 10.4903 10.7564C10.5558 10.7273 10.5942 10.717 10.6679 10.717C10.782 10.717 10.8959 10.7424 11.0094 10.7929L10.9819 10.8599C10.8769 10.8132 10.7723 10.79 10.6679 10.79C10.6051 10.79 10.5753 10.7979 10.5178 10.8235C10.4524 10.8526 10.4139 10.8629 10.3402 10.8629C10.2665 10.8629 10.2281 10.8526 10.1626 10.8235C10.1052 10.7979 10.0754 10.79 10.0126 10.79C9.90816 10.79 9.80359 10.8132 9.69861 10.8599Z'
								fill='white'
							/>
						</g>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M3.11747 9.79996C3.24367 9.64695 3.31425 9.50776 3.31425 9.35992C3.31425 9.2667 3.28651 9.18619 3.23791 9.12042L3.24612 9.11672C3.24536 9.11707 3.38457 9.05639 3.43303 9.03315C3.52313 8.98995 3.6025 8.94419 3.67989 8.88791C3.7293 8.85198 3.7955 8.81285 3.89641 8.75866L3.99125 8.70822L4.01685 8.69463C4.06589 8.66846 4.10242 8.6484 4.13635 8.62872C4.24208 8.56739 4.31195 8.5167 4.36539 8.44894C4.49196 8.28843 4.46568 8.07085 4.28831 7.95009C4.20141 7.89093 4.08415 7.85698 3.91225 7.83025L3.87665 7.82474L3.6664 7.79215C3.58415 7.77923 3.51075 7.76718 3.44531 7.75575C3.87566 7.68413 4.49019 7.71045 4.7605 7.85002L5.01741 7.35242C4.46657 7.06802 3.21149 7.09706 2.74265 7.41993C2.39878 7.65675 2.44492 8.01473 2.80271 8.16888C2.95221 8.23329 3.1471 8.27603 3.50776 8.33397C3.44732 8.36903 3.39721 8.40106 3.35052 8.43501C3.30318 8.46945 3.25245 8.49869 3.19092 8.52819C3.16149 8.5423 3.07434 8.58057 3.0344 8.59811L3.01432 8.60695C2.72289 8.73946 2.58146 8.92277 2.62372 9.25369L2.6466 9.43282L2.68764 9.44544L3.11747 9.79996ZM2.75723 9.33703L2.75634 9.33961L2.75702 9.33778L2.75723 9.33703ZM10.4412 9.35992C10.4412 9.50776 10.5118 9.64695 10.638 9.79996L11.0678 9.44544L11.1089 9.43282L11.1317 9.25369C11.174 8.92277 11.0326 8.73946 10.7411 8.60695L10.7211 8.59811L10.721 8.59807C10.681 8.58052 10.594 8.5423 10.5645 8.52819C10.503 8.49869 10.4523 8.46945 10.4049 8.43501C10.3583 8.40106 10.3081 8.36903 10.2477 8.33397C10.6084 8.27603 10.8033 8.23329 10.9528 8.16888C11.3105 8.01473 11.3567 7.65675 11.0128 7.41993C10.544 7.09706 9.2889 7.06802 8.73806 7.35242L8.99497 7.85002C9.26528 7.71045 9.8798 7.68413 10.3102 7.75575C10.2447 7.76718 10.1713 7.77923 10.0891 7.79215L9.87879 7.82475L9.84321 7.83025C9.67132 7.85698 9.55405 7.89093 9.46715 7.95009C9.28978 8.07085 9.2635 8.28843 9.39008 8.44894C9.44352 8.5167 9.51339 8.56739 9.61912 8.62872C9.65305 8.6484 9.68957 8.66846 9.73862 8.69463L9.76429 8.70826L9.85905 8.75866C9.95997 8.81285 10.0262 8.85198 10.0756 8.88791C10.153 8.94419 10.2323 8.98995 10.3224 9.03315C10.3709 9.05639 10.5101 9.11707 10.5093 9.11672L10.5176 9.12042C10.469 9.18619 10.4412 9.2667 10.4412 9.35992Z'
							fill='#AD1619'
						/>
						<path
							d='M3.7021 7.75L3.90872 7.79274V8.1007C3.68866 8.27629 3.13 8.57223 3.13 8.57223V7.75H3.7021Z'
							fill='#F1F9FF'
						/>
						<path
							d='M10.1966 7.75L9.99 7.79274V8.1007C10.2101 8.27629 10.7687 8.57223 10.7687 8.57223V7.75H10.1966Z'
							fill='#F1F9FF'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M9.235 4.50374V4.40125C8.87495 4.14284 8.4979 4.01364 8.10385 4.01364C7.72609 3.84647 7.34372 3.78158 6.95674 3.81897C6.95684 3.81777 6.9569 3.81717 6.9569 3.81717C6.37504 3.76023 5.78864 4.01364 5.78864 4.01364C5.19758 4.01364 4.6575 4.40125 4.6575 4.40125V4.50374L5.36352 5.21282C5.36352 5.21282 5.56225 5.89531 6.95402 5.73491V5.73664C6.95402 5.73664 7.87549 5.71149 7.94024 5.68995C7.96593 5.68141 7.99257 5.67363 8.0198 5.66568C8.20029 5.61299 8.40633 5.55283 8.52898 5.21282L9.235 4.50374ZM6.95402 3.85033C6.93393 4.0864 6.8192 5.50948 6.95402 5.73011V3.85033Z'
							fill='#AD1619'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M5.19606 5.09349L5.19652 5.09133L4.69983 4.62403L4.7478 4.57304L5.21387 5.01154L5.2258 4.95668C5.30205 4.97326 5.35778 4.97936 5.39027 4.97591V4.88078L5.49358 4.9367C5.5444 4.9642 5.61718 4.97159 5.71303 4.956C5.78343 4.94454 5.83094 4.86278 5.84647 4.68855L5.87783 4.33682L5.98302 4.67391C6.03061 4.82645 6.10323 4.89369 6.2066 4.89369C6.30757 4.89369 6.34815 4.85668 6.35263 4.76338L6.36534 4.49877L6.485 4.73512C6.52811 4.82026 6.58757 4.85889 6.6721 4.85889C6.79301 4.85889 6.87377 4.7581 6.87377 4.59994H6.87606H7.01377H7.01606C7.01606 4.7581 7.09682 4.85889 7.21772 4.85889C7.30226 4.85889 7.36171 4.82026 7.40482 4.73512L7.52449 4.49877L7.53719 4.76338C7.54167 4.85668 7.58226 4.89369 7.68322 4.89369C7.7866 4.89369 7.85921 4.82645 7.90681 4.67391L8.012 4.33682L8.04336 4.68855C8.05889 4.86278 8.10639 4.94454 8.1768 4.956C8.27265 4.97159 8.34543 4.9642 8.39624 4.9367L8.49956 4.88078V4.97591C8.53204 4.97936 8.58778 4.97326 8.66403 4.95668L8.68616 5.05848L9.20212 4.57304L9.25009 4.62403L8.60802 5.2281C8.51435 5.40061 8.46717 5.51448 8.46717 5.56178C8.46717 5.63395 8.27943 5.67678 7.91302 5.72077C7.62596 5.75524 7.28719 5.77837 7.01009 5.78183V5.78228L6.97496 5.78216L6.93983 5.78228V5.78183C6.66272 5.77837 6.32395 5.75524 6.0369 5.72077C5.67048 5.67678 5.48274 5.63395 5.48274 5.56178C5.48274 5.55284 5.48105 5.54151 5.47768 5.52785C5.44073 5.48079 5.41476 5.40382 5.39747 5.33438C5.38125 5.30191 5.36272 5.26645 5.34189 5.2281L5.19964 5.09426L5.19606 5.09349ZM8.63696 5.10476C8.52232 5.12505 8.43954 5.123 8.39561 5.08724C8.32691 5.10723 8.24632 5.10915 8.15431 5.09418C8.05604 5.07819 7.9876 5.01282 7.94642 4.90438C7.89266 4.97287 7.82469 5.01515 7.74326 5.02883C8.19121 5.09235 8.505 5.18165 8.505 5.18165C8.505 5.18165 8.49726 5.24799 8.47845 5.32599C8.49836 5.28516 8.52195 5.23979 8.54922 5.18971L8.55597 5.18096L8.63696 5.10476ZM7.53188 5.00222C7.49292 4.98286 7.46181 4.95479 7.43932 4.91862C7.40592 4.94811 7.36794 4.96968 7.32575 4.98299C7.39618 4.98838 7.46505 4.99489 7.53188 5.00222ZM7.07864 4.96937C7.02411 4.94417 6.97877 4.90382 6.94491 4.85212C6.91129 4.90346 6.86636 4.9436 6.81235 4.96883C6.84434 4.96788 6.87653 4.96721 6.90886 4.96685V4.96653L6.93693 4.96661L6.965 4.96653V4.96685C7.00311 4.96727 7.04101 4.96813 7.07864 4.96937ZM5.38885 5.17617L5.32359 5.11476C5.40193 5.12253 5.45992 5.11516 5.49421 5.08724C5.56292 5.10723 5.6435 5.10915 5.73552 5.09418C5.83379 5.07819 5.90222 5.01282 5.9434 4.90438C5.99561 4.97089 6.06121 5.01268 6.13952 5.02757C5.75331 5.08183 5.46515 5.15565 5.38885 5.17617ZM6.56104 4.98202C6.49322 4.98706 6.42682 4.99315 6.36225 5.00002C6.3992 4.98076 6.42885 4.95345 6.45051 4.91862C6.4831 4.9474 6.52006 4.96864 6.56104 4.98202ZM8.28313 5.56315C8.33218 5.58611 8.37149 5.56321 8.40257 5.51926C8.39988 5.5314 8.3982 5.54237 8.39752 5.5522C8.39341 5.55489 8.38712 5.55813 8.37886 5.5616C8.3558 5.57129 8.32059 5.58162 8.27478 5.59207C8.18473 5.61261 8.05657 5.63303 7.90467 5.65127C7.60806 5.68689 7.25535 5.71032 6.97496 5.71216C6.69456 5.71032 6.34186 5.68689 6.04524 5.65127C5.89335 5.63303 5.76518 5.61261 5.67514 5.59207C5.63674 5.58331 5.60579 5.57464 5.5832 5.56635C5.58568 5.56541 5.5882 5.56434 5.59074 5.56315C5.74365 5.4916 6.75483 5.42445 6.93693 5.41287C7.11903 5.42445 8.13021 5.4916 8.28313 5.56315ZM8.47597 5.55033L8.4749 5.55156L8.47554 5.55067L8.47597 5.55033Z'
							fill='#C88A02'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6.94514 3.34194C7.06112 3.34194 7.15514 3.24792 7.15514 3.13194C7.15514 3.01596 7.06112 2.92194 6.94514 2.92194C6.82916 2.92194 6.73514 3.01596 6.73514 3.13194C6.73514 3.24792 6.82916 3.34194 6.94514 3.34194Z'
							fill='#005BBF'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6.80854 4.37302C6.81302 4.39607 6.82001 4.41753 6.82886 4.43665C6.80173 4.42629 6.76953 4.42029 6.735 4.42029C6.63835 4.42029 6.56 4.4673 6.56 4.52529C6.56 4.58328 6.63835 4.63029 6.735 4.63029C6.83165 4.63029 6.91 4.58328 6.91 4.52529C6.91 4.58328 6.98835 4.63029 7.085 4.63029C7.18165 4.63029 7.26 4.58328 7.26 4.52529C7.26 4.4673 7.18165 4.42029 7.085 4.42029C7.06067 4.42029 7.0375 4.42327 7.01645 4.42865C7.02152 4.39994 7.0213 4.36703 7.01468 4.33295C6.99624 4.23808 6.93514 4.17014 6.87821 4.1812C6.82129 4.19227 6.79009 4.27815 6.80854 4.37302ZM6.91 4.52529L6.90992 4.52208L6.91008 4.52214L6.91 4.52529ZM5.77886 4.50665C5.77001 4.48753 5.76302 4.46607 5.75854 4.44302C5.74009 4.34815 5.77129 4.26227 5.82821 4.2512C5.88514 4.24014 5.94624 4.30808 5.96468 4.40295C5.9713 4.43703 5.97152 4.46994 5.96645 4.49865C5.9875 4.49327 6.01067 4.49029 6.035 4.49029C6.13165 4.49029 6.21 4.5373 6.21 4.59529C6.21 4.65328 6.13165 4.70029 6.035 4.70029C5.93835 4.70029 5.86 4.65328 5.86 4.59529L5.86008 4.59214L5.85992 4.59208L5.86 4.59529C5.86 4.65328 5.78165 4.70029 5.685 4.70029C5.58835 4.70029 5.51 4.65328 5.51 4.59529C5.51 4.5373 5.58835 4.49029 5.685 4.49029C5.71953 4.49029 5.75173 4.49629 5.77886 4.50665ZM7.9712 4.57064C7.96313 4.62806 7.879 4.66371 7.78329 4.65026C7.68759 4.63681 7.61654 4.57935 7.62461 4.52193C7.63268 4.4645 7.71681 4.42885 7.81252 4.44231C7.84672 4.44711 7.87777 4.45754 7.90319 4.47157C7.89709 4.45141 7.89315 4.42918 7.89192 4.40574C7.88686 4.30922 7.92971 4.22851 7.98762 4.22548C8.04553 4.22244 8.09658 4.29823 8.10163 4.39474C8.10345 4.42941 8.09909 4.46204 8.09007 4.48976C8.11166 4.48735 8.13502 4.48763 8.15912 4.49102C8.25482 4.50447 8.32587 4.56192 8.3178 4.61935C8.30973 4.67677 8.2256 4.71242 8.12989 4.69897C8.03418 4.68552 7.96313 4.62806 7.9712 4.57064ZM7.9712 4.57064L7.97157 4.56745L7.97172 4.56753L7.9712 4.57064ZM8.63772 4.8483C8.72305 4.89367 8.8143 4.88895 8.84153 4.83775L8.84296 4.83488C8.85137 4.84378 8.86132 4.85025 8.87267 4.85372C8.92813 4.87068 8.99599 4.8095 9.02425 4.71707C9.05251 4.62464 9.03046 4.53597 8.975 4.51902C8.91954 4.50206 8.85168 4.56324 8.82342 4.65567C8.81656 4.67812 8.81266 4.70036 8.81149 4.72139C8.79241 4.69951 8.7668 4.67909 8.7363 4.66288C8.65097 4.6175 8.55972 4.62223 8.53249 4.67343C8.50527 4.72463 8.55238 4.80292 8.63772 4.8483ZM5.20301 4.86974C5.11767 4.91512 5.02642 4.91039 4.9992 4.85919C4.9987 4.85824 4.99822 4.85729 4.99776 4.85632C4.98936 4.86522 4.97941 4.8717 4.96805 4.87517C4.9126 4.89212 4.84473 4.83094 4.81648 4.73851C4.78822 4.64609 4.81027 4.55741 4.86572 4.54046C4.92118 4.5235 4.98904 4.58469 5.0173 4.67711C5.02417 4.69957 5.02806 4.7218 5.02923 4.74283C5.04831 4.72095 5.07393 4.70054 5.10442 4.68432C5.18976 4.63895 5.28101 4.64367 5.30823 4.69487C5.33545 4.74608 5.28835 4.82437 5.20301 4.86974Z'
							fill='#C88A02'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6.86676 2.54788H7.01259V2.64001H7.10788V2.78584H7.01259V3.07751H7.10788V3.22334H6.76999V3.07751H6.86676V2.78584H6.76999V2.64001H6.86676V2.54788Z'
							fill='#C88A02'
						/>
						<rect x='6.84' y='3.34' width='0.28' height='0.91' fill='#C88A02' />
						<path
							d='M5.71286 3.49241L5.71164 3.5624C5.09095 3.55156 4.73492 3.64214 4.64454 3.82267C4.5511 4.00931 4.56848 4.2362 4.6994 4.50572L4.63644 4.5363C4.49675 4.24874 4.47767 3.99963 4.58194 3.79134C4.68928 3.57693 5.06591 3.48111 5.71286 3.49241Z'
							fill='white'
						/>
						<path
							d='M5.83295 4.11312L5.79706 4.17322C5.66189 4.09252 5.59424 3.95478 5.59424 3.76497C5.59424 3.49217 5.73477 3.3322 6.04561 3.22272C6.244 3.15285 6.51501 3.1815 6.85939 3.30636L6.83553 3.37217C6.50493 3.25231 6.24912 3.22527 6.06886 3.28875C5.78375 3.38916 5.66424 3.52521 5.66424 3.76497C5.66424 3.93154 5.72043 4.04594 5.83295 4.11312Z'
							fill='white'
						/>
						<path
							d='M4.7876 4.39836L4.65551 4.44475C4.51846 4.05454 4.5576 3.78953 4.79178 3.67521C4.99813 3.57448 5.29887 3.53349 5.6955 3.54956L5.68983 3.68945C5.31431 3.67423 5.03493 3.71231 4.85319 3.80102C4.69929 3.87615 4.67114 4.06677 4.7876 4.39836Z'
							fill='#C88A02'
						/>
						<path
							d='M6.33079 3.39919C6.0107 3.39919 5.87926 3.47714 5.80416 3.70732C5.75631 3.85401 5.80272 3.97921 5.95322 4.09607L5.86735 4.20665C5.67251 4.05535 5.60381 3.87005 5.67107 3.6639C5.76677 3.37056 5.95456 3.25919 6.33079 3.25919C6.57739 3.25919 6.76949 3.32397 6.90324 3.45582L6.9241 3.47638V4.15136H6.7841V3.53622C6.67964 3.44549 6.52959 3.39919 6.33079 3.39919Z'
							fill='#C88A02'
						/>
						<path
							d='M8.15561 3.56241L8.15683 3.6324C8.77752 3.62157 9.13355 3.71215 9.22393 3.89268C9.31737 4.07932 9.29999 4.30621 9.16907 4.57573L9.23203 4.60631C9.37172 4.31875 9.3908 4.06963 9.28653 3.86134C9.17919 3.64694 8.80255 3.55112 8.15561 3.56241Z'
							fill='white'
						/>
						<path
							d='M7.93643 4.12768L7.97232 4.18778C8.10749 4.10707 8.17514 3.96934 8.17514 3.77953C8.17514 3.50673 8.03461 3.34675 7.72377 3.23728C7.52538 3.16741 7.25437 3.19606 6.90999 3.32092L6.93385 3.38673C7.26445 3.26686 7.52026 3.23982 7.70051 3.3033C7.98563 3.40372 8.10514 3.53976 8.10514 3.77953C8.10514 3.9461 8.04895 4.0605 7.93643 4.12768Z'
							fill='white'
						/>
						<path
							d='M9.12451 4.46837L9.2566 4.51476C9.39365 4.12454 9.35451 3.85954 9.12033 3.74522C8.91398 3.64449 8.61324 3.6035 8.21661 3.61957L8.22228 3.75945C8.5978 3.74424 8.87718 3.78232 9.05892 3.87103C9.21282 3.94616 9.24097 4.13678 9.12451 4.46837Z'
							fill='#C88A02'
						/>
						<path
							d='M7.57329 3.41002C7.89338 3.41002 8.02482 3.48798 8.09992 3.71816C8.14777 3.86485 8.10136 3.99004 7.95087 4.10691L8.03674 4.21748C8.23157 4.06618 8.30027 3.88088 8.23301 3.67474C8.13731 3.38139 7.94953 3.27002 7.57329 3.27002C7.32669 3.27002 7.1346 3.33481 7.00084 3.46666L6.97998 3.48722V4.1622H7.11998V3.54706C7.22445 3.45632 7.3745 3.41002 7.57329 3.41002Z'
							fill='#C88A02'
						/>
						<path
							opacity='0.3'
							fillRule='evenodd'
							clipRule='evenodd'
							d='M4.66998 5.79001H9.21998V9.87803C9.21998 9.87803 8.882 11.25 6.94498 11.25C5.00797 11.25 4.66998 9.84185 4.66998 9.84185V5.79001Z'
							fill='#E1E5E8'
						/>
						<mask
							id='mask4_11534_5657'
							style={{ maskType: 'luminance' }}
							maskUnits='userSpaceOnUse'
							x='4'
							y='5'
							width='6'
							height='7'
						>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M4.66998 5.79001H9.21998V9.87803C9.21998 9.87803 8.882 11.25 6.94498 11.25C5.00797 11.25 4.66998 9.84185 4.66998 9.84185V5.79001Z'
								fill='white'
							/>
						</mask>
						<g mask='url(#mask4_11534_5657)'>
							<rect
								x='4.66998'
								y='8.31'
								width='2.31'
								height='2.73'
								fill='#FFC034'
							/>
							<rect
								x='4.94998'
								y='8.45001'
								width='0.28'
								height='2.59'
								fill='#AD1619'
							/>
							<rect
								x='5.92999'
								y='8.45001'
								width='0.28'
								height='2.59'
								fill='#AD1619'
							/>
							<rect
								x='5.43997'
								y='8.45001'
								width='0.28'
								height='2.59'
								fill='#AD1619'
							/>
							<rect
								x='6.41998'
								y='8.45001'
								width='0.28'
								height='2.59'
								fill='#AD1619'
							/>
							<rect
								x='4.66998'
								y='5.72'
								width='2.31'
								height='2.66'
								fill='#AD1619'
							/>
							<rect
								x='6.90997'
								y='8.24002'
								width='2.31'
								height='2.66'
								fill='#AD1619'
							/>
							<rect
								x='6.90997'
								y='5.79001'
								width='2.45'
								height='2.59'
								fill='#F1F9FF'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M5.64997 6H5.85997V6.58074H5.99997V6.29037H6.20997V6.58074H6.41997V6.9437H6.20997V7.59704H6.41997V7.96H5.15997V7.59704H5.36997V6.9437H5.15997V6.58074H5.29997V6.29037H5.50997V6.58074H5.64997V6Z'
								fill='#C88A02'
							/>
							<path
								d='M8.11176 6.1219L8.25511 5.96844L8.55607 6.24959L8.41272 6.40304L8.11176 6.1219Z'
								fill='#C88A02'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M8.97498 10.0876V8.55502H7.22498V10.0747L7.22775 10.0866C7.31634 10.464 7.61803 10.655 8.09998 10.655C8.58146 10.655 8.88311 10.469 8.97206 10.0997L8.97498 10.0876ZM8.09998 10.445C7.71328 10.445 7.50211 10.3148 7.43498 10.05V8.76502H8.76498V10.0621C8.69801 10.3183 8.48682 10.445 8.09998 10.445Z'
								fill='#FFC034'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M8.17223 8.68311H8.0264V9.3779L7.45151 8.75264L7.34845 8.84739L7.86836 9.41285H7.39729V9.62285H7.75915H7.87981L7.34845 10.2008L7.45151 10.2955L8.0264 9.67027V10.4824H8.17223V9.74335L8.67992 10.2955L8.78298 10.2008L8.25162 9.62285H8.84472V9.41285H8.26308L8.78298 8.84739L8.67992 8.75264L8.17223 9.30481V8.68311Z'
								fill='#FFC034'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M8.42669 10.9017C8.42669 10.9017 6.94407 11.0183 6.94407 10.062C6.94407 10.062 6.92993 10.9017 5.38181 10.9017V11.6566H8.42669V10.9017Z'
								fill='#F1F9FF'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M6.94498 8.87C7.23493 8.87 7.46998 8.61928 7.46998 8.31C7.46998 8.00072 7.23493 7.75 6.94498 7.75C6.65503 7.75 6.41998 8.00072 6.41998 8.31C6.41998 8.61928 6.65503 8.87 6.94498 8.87Z'
								fill='#005BBF'
								stroke='#AD1619'
								strokeWidth='0.729167'
							/>
						</g>
					</g>
				</g>
			</g>
			<rect
				x='0.5'
				y='0.5'
				width='19'
				height='14'
				rx='1'
				stroke='black'
				strokeOpacity='0.1'
			/>
			<defs>
				<clipPath id='clip0_11534_5657'>
					<rect width='20' height='15' rx='1.5' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
